{
  "successTitle": "Revisa tu correo",
  "successMessage": "Enviamos un enlace de verificación a",
  "instructions": "Haz clic en el enlace del correo para verificar tu cuenta y completar el registro.",
  "expiryNote": "El enlace expirará en 1 hora",
  "resendButton": "Reenviar correo de verificación",
  "resendingButton": "Enviando...",
  "backToLogin": "Volver al inicio",
  "failureTitle": "Verificación fallida",
  "errors": {
    "invalidOrExpired": "Enlace de verificación inválido o expirado. Por favor, solicita uno nuevo.",
    "genericError": "Ocurrió un error. Inténtalo de nuevo.",
    "noEmail": "No hay correo disponible. Por favor, regístrate de nuevo.",
    "resendFailed": "No se pudo reenviar el correo de verificación. Intenta de nuevo."
  }
}
